export default __webpack_public_path__ + "14fedabdee4ccea5aa21f6a19ae3f38e.svg";